export const colors = {
  default: {
    young: ["lightgreen", "gold", "#fb8181", "#54bbf7", "purple"],
    middle: ["lightgreen", "gold", "#fb8181", "#54bbf7", "purple"],
    old: ["darkgreen", "#ebb400", "red", "#0099ff", "#5d0e5d"],
  },
  simple: {
    young: ["lightgreen", "lightgreen", "lightgreen", "lightgreen", "lightgreen"],
    middle: ["#00BD00", "#00BD00", "#00BD00", "#00BD00", "#00BD00"],
    old: ["darkgreen", "darkgreen", "darkgreen", "darkgreen", "darkgreen"],
  },
  muted: {
    young: ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"],
    middle: ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"],
    old: ["#8FFF80", "#ebb400", "#FF8080", "#80FFFF", "#BF80FF"],
  },
  mutedsame: {
    young: ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"],
    middle: ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"],
    old: ["#BCFFB3", "gold", "#FFB3B3", "#B3FFFF", "#D9B3FF"],
  },
};

export function selectColorPair(youngVal, ranges, oldVal, colorBook = "muted") {
  let youngColor = colors[colorBook].young[0];
  if (youngVal < ranges["Ok Low"]) {
    youngColor = colors[colorBook].young[1];
  }
  if (youngVal < ranges["Very Low"]) {
    youngColor = colors[colorBook].young[2];
  }
  if (youngVal > ranges["Ok High"]) {
    youngColor = colors[colorBook].young[3];
  }
  if (youngVal > ranges["Very High"]) {
    youngColor = colors[colorBook].young[4];
  }
  let oldColor = colors[colorBook].old[0];
  if (oldVal < ranges["Ok Low"]) {
    oldColor = colors[colorBook].old[1];
  }
  if (oldVal < ranges["Very Low"]) {
    oldColor = colors[colorBook].old[2];
  }
  if (oldVal > ranges["Ok High"]) {
    oldColor = colors[colorBook].old[3];
  }
  if (oldVal > ranges["Very High"]) {
    oldColor = colors[colorBook].old[4];
  }
  return { youngColor, oldColor };
}

export function selectColor(val, ranges, plantPart = "young", colorBook = "muted") {
  let color = colors[colorBook][plantPart][0];
  if (val < ranges["Ok Low"]) {
    color = colors[colorBook][plantPart][1];
  }
  if (val < ranges["Very Low"]) {
    color = colors[colorBook][plantPart][2];
  }
  if (val > ranges["Ok High"]) {
    color = colors[colorBook][plantPart][3];
  }
  if (val > ranges["Very High"]) {
    color = colors[colorBook][plantPart][4];
  }

  return color;
}
